
export const CROSS_DOCK_DRAFT = 'draft';

export const CROSS_DOCK_IN_CALCULATION = 'in_calculation';

export const CROSS_DOCK_COMPLETED = 'completed';

export const CROSS_DOCK_AGREED = 'agreed';

export const CROSS_DOCK_REFUSED = 'refused';